var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suspend"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backToTopShow),expression:"backToTopShow"}],staticClass:"back-to-top"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.backToTop}},[_vm._t("back-to-top")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }